import { render, staticRenderFns } from "./summary-pension-and-insurance.vue?vue&type=template&id=364b8fb6&scoped=true&"
import script from "./summary-pension-and-insurance.vue?vue&type=script&lang=js&"
export * from "./summary-pension-and-insurance.vue?vue&type=script&lang=js&"
import style0 from "./summary-pension-and-insurance.vue?vue&type=style&index=0&id=364b8fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b8fb6",
  null
  
)

export default component.exports